import Bird from "./bird";
import Bug from "./bug";
import BugOff from "./bug-off";
import BugPlay from "./bug-play";
import Camel from "./camel";
import Cat from "./cat";
import Crab from "./crab";
import Dog from "./dog";
import Fish from "./fish";
import FishOff from "./fish-off";
import FishSymbol from "./fish-symbol";
import Horse from "./horse";
import HorseHead from "./horse-head";
import HorseSaddle from "./horse-saddle";
import Origami from "./origami";
import PawPrint from "./paw-print";
import Rabbit from "./rabbit";
import Rat from "./rat";
import RubberDuck from "./rubber-duck";
import Shell from "./shell";
import Shellfish from "./shellfish";
import Snail from "./snail";
import Squirrel from "./squirrel";
import Turtle from "./turtle";
import Worm from "./worm";

export * from "./bird";
export * from "./bug";
export * from "./bug-off";
export * from "./bug-play";
export * from "./cat";
export * from "./dog";
export * from "./fish";
export * from "./fish-off";
export * from "./fish-symbol";
export * from "./origami";
export * from "./paw-print";
export * from "./rabbit";
export * from "./shell";
export * from "./snail";
export * from "./squirrel";
export * from "./turtle";
export * from "./worm";
export * from "./rat";
export * from "./rubber-duck";
export * from "./camel";
export * from "./crab";
export * from "./horse";
export * from "./horse-head";
export * from "./horse-saddle";
export * from "./shellfish";

export const Animals = {
  Bird,
  Bug,
  BugOff,
  BugPlay,
  Cat,
  Dog,
  Fish,
  FishOff,
  FishSymbol,
  Origami,
  PawPrint,
  Rabbit,
  Shell,
  Snail,
  Squirrel,
  Turtle,
  Worm,
  Rat,
  RubberDuck,
  Camel,
  Crab,
  Horse,
  HorseHead,
  HorseSaddle,
  Shellfish,
};
